import { render, staticRenderFns } from "./FrundOrgDeals.vue?vue&type=template&id=36bb1a34&"
import script from "./FrundOrgDeals.vue?vue&type=script&lang=js&"
export * from "./FrundOrgDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports